import { render } from "./MassCreateEditModal.vue?vue&type=template&id=8f2b8518"
import script from "./MassCreateEditModal.vue?vue&type=script&lang=js"
export * from "./MassCreateEditModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__